const isAgent = deliveryIdentifierData => {
  const isSenderOfOutgoing = deliveryIdentifierData.latestSenderOfOutgoingMessage && !deliveryIdentifierData.latestSenderOfIncomingMessage;
  const isRecipientOfIncoming = deliveryIdentifierData.latestRecipientOfIncomingMessage && !deliveryIdentifierData.latestRecipientOfOutgoingMessage;
  return Boolean(isSenderOfOutgoing || isRecipientOfIncoming);
};
export const getSingleAgentDeliveryIdentifier = threadDeliveryIdentifiers => {
  return threadDeliveryIdentifiers.find(d => isAgent(d));
};